/**
 * Where an unfinished tenant is held.
 *
 * Its own module so `RequireAuth` can redirect here without importing the page
 * — the gate runs on every navigation and must not drag the wizard's bundle in
 * behind it.
 */
export const ONBOARDING_ROUTE = '/onboarding';

/** A customer's own onboarding form. */
export const CUSTOMER_PROFILE_ROUTE = '/customer-profile';

/**
 * Routes an unfinished tenant may still reach.
 *
 * The wizard sends people to the *real* portal pages rather than reimplementing
 * them — a provider fills in the same profile-and-pricing screen and the same
 * equipment screen they will use forever afterwards. Those pages sit behind the
 * same gate as everything else, so without this they would bounce straight back
 * to the wizard that just linked to them.
 *
 * Kept as an explicit short list rather than a prefix rule: the point of the
 * gate is that a half-onboarded tenant reaches nothing else, and "anything
 * starting with /provider" would quietly include pages nobody vetted.
 */
export const ONBOARDING_ALLOWED_ROUTES = [
  ONBOARDING_ROUTE,
  CUSTOMER_PROFILE_ROUTE,
  '/provider-profile',
  '/provider-equipment',
];

/** True when the gate must let this path through. */
export function isOnboardingRoute(pathname: string): boolean {
  return ONBOARDING_ALLOWED_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
}
